<template>
  <!-- Modo resumen: el título ya vive en la pestaña, acá solo ícono +
       subtítulo (mismo lenguaje que .dashboard-page-heading__summary).
       En mobile no se renderiza: ese contenido está en la burbuja del tab. -->
  <div v-if="view && summaryOnly" class="module-view-heading module-view-heading--summary d-none d-md-flex">
    <span v-if="view.icon" class="module-view-heading__icon module-view-heading__icon--summary">
      <AppIcon :name="view.icon" />
    </span>
    <p v-if="view.subtitle" class="module-view-heading__summary-text">{{ view.subtitle }}</p>
  </div>

  <div v-else-if="view" class="module-view-heading">
    <span v-if="view.icon" class="module-view-heading__icon d-none d-md-inline-flex">
      <AppIcon :name="view.icon" font-scale="1.5" weight="550" />
    </span>
    <div>
      <h4 class="card-title mb-0">{{ view.title }}</h4>
      <div v-if="view.subtitle" class="small text-muted d-none d-md-block">{{ view.subtitle }}</div>
    </div>
  </div>
</template>

<script>
import Session from '@/handler/session'
import { EventBus } from '@/handler/event-bus'

export default {
  data() {
    return {
      metadataRevision: 0,
    }
  },
  props: {
    moduleId: {
      type: Number,
      required: true,
    },
    profileId: {
      type: Number,
      required: true,
    },
    reference: {
      type: String,
      required: true,
    },
    // true = solo ícono + subtítulo (para vistas donde el título ya está en
    // la pestaña, como los listados del estándar list-view-interfaces).
    summaryOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    view() {
      return Session.getViewMetadata(
        this.moduleId,
        this.profileId,
        this.reference,
        this.metadataRevision
      )
    },
  },
  created() {
    EventBus.$on('ViewMetadata:updated', this.refreshMetadata)
  },
  beforeDestroy() {
    EventBus.$off('ViewMetadata:updated', this.refreshMetadata)
  },
  methods: {
    refreshMetadata() {
      this.metadataRevision++
    },
  },
}
</script>

<style scoped>
.module-view-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}

.module-view-heading__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 8px;
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
  font-size: 1rem;
}

/* Variante resumen: mismos números que .dashboard-page-heading__summary
   (SimpleModuleDashboard.vue), para que dashboards y listados se lean igual. */
.module-view-heading--summary {
  gap: 8px;
  min-height: 36px;
}
.module-view-heading__icon--summary {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  font-size: 0.85rem;
}
.module-view-heading__summary-text {
  margin: 0;
  color: var(--app-color-text-secondary);
  font-size: var(--app-text-sm);
  font-weight: var(--app-font-medium);
}
</style>
